const apiUrl = process.env.REACT_APP_API_URL;

export const GetConjuntsPildores = async (userId: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/pildores/list`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: userId })
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los conjunts de pildores:', error);
        return [];
    }
};
